import type { JSX, SVGProps } from "react";
import { CloseLinedIcon } from "../../app/renderer/components/icons/CloseLinedIcon";
const GUIDE_LINED_PATH =
  "M8.29297 3.29297C8.68349 2.90245 9.31651 2.90245 9.70703 3.29297C10.0975 3.6835 10.0975 4.31652 9.70703 4.70703L6.41406 8H16C17.3261 8 18.5975 8.52716 19.5352 9.46484C20.4728 10.4025 21 11.6739 21 13V20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20V13C19 12.2044 18.6837 11.4415 18.1211 10.8789C17.5585 10.3163 16.7956 10 16 10H6.41406L9.70703 13.293C10.0975 13.6835 10.0975 14.3165 9.70703 14.707C9.31652 15.0975 8.68348 15.0975 8.29297 14.707L3.29297 9.70703C3.24631 9.66037 3.20472 9.60881 3.16797 9.55371C3.14195 9.51472 3.11956 9.47412 3.09961 9.43262C3.07767 9.38704 3.05788 9.34011 3.04297 9.29102C3.0379 9.27429 3.03445 9.25716 3.03027 9.24024C3.01125 9.16319 3.00001 9.08292 3 9C3 8.92032 3.00974 8.84285 3.02734 8.76856C3.03221 8.748 3.03678 8.7273 3.04297 8.70703C3.05787 8.65828 3.07777 8.61168 3.09961 8.56641C3.11877 8.52661 3.1403 8.48768 3.16504 8.4502C3.20242 8.39354 3.24516 8.34078 3.29297 8.29297L8.29297 3.29297Z";
const MORE_LINED_PATH =
  "M5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10Z";
const TRASH_LINED_PATH =
  "M14 1C14.7956 1 15.5585 1.3163 16.1211 1.87891C16.6837 2.44152 17 3.20435 17 4V5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H20V20C20 20.7957 19.6837 21.5585 19.1211 22.1211C18.5585 22.6837 17.7957 23 17 23H7C6.20435 23 5.44152 22.6837 4.87891 22.1211C4.3163 21.5585 4 20.7956 4 20V7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H7V4C7 3.20435 7.3163 2.44152 7.87891 1.87891C8.44152 1.3163 9.20435 1 10 1H14ZM6 20C6 20.2652 6.10543 20.5195 6.29297 20.707C6.48051 20.8946 6.73478 21 7 21H17C17.2652 21 17.5195 20.8946 17.707 20.707C17.8946 20.5195 18 20.2652 18 20V7H6V20ZM10 3C9.73478 3 9.48051 3.10543 9.29297 3.29297C9.10543 3.48051 9 3.73478 9 4V5H15V4C15 3.73478 14.8946 3.48051 14.707 3.29297C14.5195 3.10543 14.2652 3 14 3H10Z";

/** Source: carried canvas-node-max-lined.svg asset. */
const MAXIMIZE_LINED_PATH =
  "M9.29297 13.293C9.68349 12.9024 10.3165 12.9024 10.707 13.293C11.0976 13.6835 11.0976 14.3165 10.707 14.707L6.41406 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H4C3.94333 21 3.88808 20.9934 3.83398 20.9844C3.82358 20.9826 3.81309 20.9816 3.80273 20.9795C3.79123 20.9772 3.77991 20.9744 3.76855 20.9717C3.74799 20.9668 3.72732 20.9623 3.70703 20.9561C3.65838 20.9412 3.61159 20.9222 3.56641 20.9004C3.52662 20.8812 3.48768 20.8597 3.4502 20.835C3.31255 20.7441 3.19887 20.6203 3.12012 20.4746C3.11269 20.4609 3.10634 20.4466 3.09961 20.4326C3.0778 20.3873 3.05783 20.3408 3.04297 20.292C3.0303 20.2503 3.02176 20.2077 3.01465 20.165C3.00571 20.1113 3 20.0563 3 20V14C3 13.4477 3.44772 13 4 13C4.55228 13 5 13.4477 5 14V17.5859L9.29297 13.293ZM20 3C20.0563 3 20.1113 3.00571 20.165 3.01465C20.1738 3.01611 20.1827 3.01686 20.1914 3.01855L20.2012 3.02051C20.211 3.02252 20.2207 3.02504 20.2305 3.02734C20.251 3.0322 20.2717 3.0368 20.292 3.04297C20.3408 3.05783 20.3873 3.0778 20.4326 3.09961C20.4466 3.10634 20.4609 3.11269 20.4746 3.12012C20.6203 3.19887 20.7441 3.31255 20.835 3.4502C20.8597 3.48768 20.8812 3.52662 20.9004 3.56641C20.9222 3.61159 20.9412 3.65838 20.9561 3.70703C20.9623 3.72732 20.9668 3.74799 20.9717 3.76855C20.9893 3.84294 21 3.92022 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41406L14.707 10.707C14.3165 11.0976 13.6835 11.0976 13.293 10.707C12.9024 10.3165 12.9024 9.68349 13.293 9.29297L17.5859 5H14C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20Z";

/** Restore-from-maximized glyph. */
const MINIMIZE_LINED_PATH =
  "M10.0001 13C10.0587 13 10.116 13.0059 10.1719 13.0156C10.212 13.0226 10.2519 13.0311 10.2911 13.043C10.3402 13.0579 10.3871 13.0777 10.4327 13.0996C10.4742 13.1196 10.5148 13.142 10.5538 13.168C10.6653 13.2424 10.7612 13.3382 10.835 13.4502C10.8802 13.5186 10.9149 13.5917 10.9415 13.667C10.9462 13.6804 10.9519 13.6934 10.9561 13.707C10.9623 13.7273 10.9669 13.748 10.9717 13.7686C10.9894 13.8429 11.0001 13.9203 11.0001 14V20C11 20.5522 10.5523 21 10.0001 21C9.4478 21 9.0001 20.5523 9.00006 20V16.4141L4.70708 20.707C4.31658 21.0975 3.68355 21.0975 3.29302 20.707C2.90249 20.3165 2.90249 19.6835 3.29302 19.293L7.58599 15H4.00005C3.44779 15 3.00009 14.5523 3.00005 14C3.00005 13.4477 3.44776 13 4.00005 13H10.0001ZM19.293 3.29295C19.6836 2.90243 20.3166 2.90243 20.7071 3.29295C21.0976 3.68348 21.0976 4.31652 20.7071 4.70702L16.4141 9H20.0001C20.5523 9.00004 21.0001 9.44774 21.0001 10C21 10.5522 20.5523 11 20.0001 11H14.0001L13.8975 10.9951C13.876 10.9929 13.8551 10.9879 13.8341 10.9844C13.8237 10.9826 13.8132 10.9816 13.8028 10.9795C13.7913 10.9772 13.78 10.9744 13.7686 10.9717C13.7481 10.9668 13.7274 10.9623 13.7071 10.9561C13.6935 10.9519 13.6804 10.9461 13.6671 10.9414C13.6497 10.9353 13.6324 10.929 13.6153 10.9219C13.6064 10.9182 13.5977 10.9141 13.5889 10.9102C13.5413 10.8887 13.4947 10.8643 13.4503 10.835C13.3383 10.7611 13.2424 10.6653 13.168 10.5537C13.142 10.5147 13.1196 10.4741 13.0997 10.4326C13.0777 10.387 13.058 10.3401 13.043 10.291C13.038 10.2743 13.0345 10.2572 13.0303 10.2402C13.0113 10.1632 13.0001 10.0829 13.0001 10V3.99999C13.0001 3.4477 13.4478 2.99998 14.0001 2.99998C14.5523 3.00003 15.0001 3.44773 15.0001 3.99999V7.58593L19.293 3.29295Z";
const LAYOUT_LINED_PATH =
  "M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19ZM4 13V19C4 19.5523 4.44772 20 5 20H14V13H4ZM16 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H16V20ZM5 4C4.44772 4 4 4.44772 4 5V11H14V4H5Z";
const PANEL_LINED_FRAME_PATH =
  "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM19 4C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H19Z";
const PANEL_LINED_RAIL_PATH =
  "M5 5H10.5C10.7761 5 11 5.22386 11 5.5V18.5C11 18.7761 10.7761 19 10.5 19H5V5Z";

export function CanvasNodeCloseIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return <CloseLinedIcon className={className} {...props} />;
}

export function CanvasNodeGuideLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={GUIDE_LINED_PATH} fill="currentColor" />
    </svg>
  );
}

export function CanvasNodeMoreLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={MORE_LINED_PATH} fill="currentColor" />
    </svg>
  );
}

export function CanvasNodeTrashLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={TRASH_LINED_PATH} fill="currentColor" />
    </svg>
  );
}

export function CanvasNodeMaximizeLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={MAXIMIZE_LINED_PATH} fill="currentColor" />
    </svg>
  );
}

export function CanvasNodeMinimizeLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={MINIMIZE_LINED_PATH} fill="currentColor" />
    </svg>
  );
}

export function CanvasNodeLayoutLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={LAYOUT_LINED_PATH} fill="currentColor" />
    </svg>
  );
}

export function CanvasNodePanelLinedIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  "use memo";
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      data-tutti-chrome-glyph="fill"
      data-nexight-chrome-glyph="fill"
    >
      <path d={PANEL_LINED_FRAME_PATH} fill="currentColor" />
      <path d={PANEL_LINED_RAIL_PATH} fill="currentColor" opacity={0.3} />
    </svg>
  );
}
